import { UpdateAboutUserInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateAboutUserInputSchema: z.ZodType<UpdateAboutUserInput> =
  z.object({
    education: z.string(),
    years_exp: z.string(),
    crp: z.string(),
    bio: z.string(),
  });
